class MessageController {
  /* @ngInject */
  constructor ($mdDialog) {
    this.$mdDialog = $mdDialog
  }

  cancel () {
    this.$mdDialog.cancel()
  }

  hide () {
    this.$mdDialog.hide(this.message)
  }
}

export default MessageController
